<h1 align="center" mat-dialog-title>{{title}}</h1>
<div mat-dialog-content [innerHTML]="html"></div>
<div mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</div>
